import React, { Children, lazy, Suspense, useEffect, useState } from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import ReactMarkdown from "react-markdown";
import {
  darcula,
  materialDark,
} from "react-syntax-highlighter/dist/cjs/styles/prism";
import remarkGfm from "remark-gfm";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";
import rehypeRaw from "rehype-raw";
import remarkImages from "remark-images";
import { LinkPreview } from "@dhaiwat10/react-link-preview";
import { Col } from "react-bootstrap";
import { serverUrl } from "../config";
import { useParams } from "react-router-dom";

function MdPage() {
  const [MarkDown, setMarkDown] = useState("");

  const {mdName} = useParams();

  useEffect(() => {
    fetch(`${serverUrl}/${mdName}`)
      .then((res) => res.text())
      .then((md) => setMarkDown(md));
  }, []);

  return (
    <Col xs={8}>
      <ReactMarkdown
        children={MarkDown}
        components={{
          code({ node, inline, className, children, ref, ...props }: any) {
            const match = /language-(\w+)/.exec(className || "");
            return !inline && match ? (
              <SyntaxHighlighter
                style={{ ...materialDark, margin: 0 }}
                children={String(children).replace(/\n$/, "")}
                language={match[1]}
                PreTag="div"
                {...props}
              />
            ) : (
              <code className={className} {...props}>
                {children}
              </code>
            );
          },
          a({ node, inline, className, children, ref, ...props }: any) {
            return (
              <LinkPreview
                url={node.properties.href}
                imageHeight="0"
                height="20vh"
                descriptionLength={150}
                className={className}
                {...props}
              />
            );
          },
          img({ node, inline, className, children, ref, ...props }: any) {
            return (
              <div style={{ textAlign: "center" }} className={"img_wrapper"}>
                <img
                  children={children}
                  className={"markdown_img"}
                  {...props}
                ></img>
              </div>
            );
          },
          p({ node, inline, className, children, ref, ...props }: any) {
            return children[0].tagName != "p" ? (
              <div children={children}></div>
            ) : (
              <p className={className} {...props} children={children}></p>
            );
          },
        }}
        remarkPlugins={[remarkMath, remarkGfm, remarkImages]}
        rehypePlugins={[rehypeKatex, rehypeRaw]}
      />
    </Col>
  );
}

export default MdPage;
